import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import PortfolioCategories from '../layouts/portfolio/PortfolioCategories'
import AppScreensSlider from '../layouts/portfolio/AppScreensSlider'
import FinalCTA from '../layouts/FinalCTA'

const Portfolio = () => {
  return (
    <>
      <Header />
      <PortfolioCategories/>
      <AppScreensSlider/>
      <FinalCTA/>
      <Footer />
    </>
  )
}

export default Portfolio